<template>
    <div class="main-wrapper">
        <layouts></layouts>

        <div class="page-wrapper">
            <breadcrumb :title="title" :name="name" :text="text" :text1="text1" />
            
            <gallerypage />

            <foot /> 

            <scroll /> 
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            title: "Gallery",
            text: "Home",
            text1: "Gallery",
            name: "/",
        }
    },
}
</script>